// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React, { useRef } from 'react';
import { Size } from '@front/sharedcomponents/Variables';
import { useCombobox } from './useCombobox';
import { ComboboxSelectorDecorator } from './Elements/ComboboxSelectorDecorator';
import { ComboboxDropdown } from './Elements/ComboboxDropdown';
import { ComboboxDropdownItemDecorator } from './Elements/ComboboxDropdownItemDecorator';
import { TypographyLevel } from '../Typography/TypographyLevel';
import { Typography } from '../Typography/Typography';
export const Combobox = ({ isArrowVisible = true, options = [], value = null, isComboboxItemMode = false, size = Size.Medium, disabled = false, onValueChange }) => {
    var _a;
    const comboboxRef = useRef(null);
    const comboboxPopoverRef = useRef(null);
    const { isOpened, selectedItem, dropdownPosition, dropdownMinWidth, generateKey, toggleOpen, onSelect } = useCombobox({
        comboboxRef,
        comboboxPopoverRef,
        options,
        value,
        isComboboxItemMode,
        onValueChange
    });
    const text = (_a = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.text) !== null && _a !== void 0 ? _a : '';
    const renderItem = (itemText) => {
        return (React.createElement(Typography, { level: TypographyLevel.BodyMd, noWrap: true }, itemText));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ComboboxSelectorDecorator, { ref: comboboxRef, isArrowVisible: isArrowVisible, size: size, disabled: disabled, selected: isOpened, "aria-label": text, onClick: toggleOpen }, renderItem(text)),
        React.createElement(ComboboxDropdown, { ref: comboboxPopoverRef, comboboxRef: comboboxRef, isOpened: isOpened, position: dropdownPosition, minWidth: dropdownMinWidth, onOutsideClick: toggleOpen }, options.map((item, index) => {
            return (React.createElement(ComboboxDropdownItemDecorator, { key: generateKey(item, index), isSelected: item.value === value, size: size, onClick: () => onSelect(item), "aria-label": item.text }, renderItem(item.text)));
        }))));
};
